interface ReaderPageImageProps {
    src: string;
    alt: string;
    fetchPriority?: 'high' | 'low' | 'auto';
    /** Largura máxima da imagem em % (ex.: 85). */
    zoomPercent?: number;
    /** `filter: brightness()` em % (100 = normal). */
    brightnessPercent?: number;
}

export default function ReaderPageImage({
    src,
    alt,
    fetchPriority = 'auto',
    zoomPercent = 100,
    brightnessPercent = 100,
}: ReaderPageImageProps) {
    const z = Math.min(120, Math.max(50, zoomPercent));
    const b = Math.min(140, Math.max(40, brightnessPercent));

    return (
        <div className="w-full flex justify-center bg-black">
            <img
                src={src}
                alt={alt}
                className="h-auto object-contain mx-auto w-full max-w-full md:max-w-none"
                style={{
                    maxWidth: `${z}%`,
                    filter: `brightness(${b}%)`,
                }}
                loading={fetchPriority === 'high' ? 'eager' : 'lazy'}
                fetchPriority={fetchPriority}
                decoding="async"
            />
        </div>
    );
}
